import styled from "styled-components";
import { JackpotThemeType } from "../../../../../services/jackpots/jackpot.constants";
import {JackpotWidgetAmountLabelDefaultBox} from "./jackpot-widget-amount-label.default.box";

export const JackpotWidgetAmountLabelCasino777Box = styled(JackpotWidgetAmountLabelDefaultBox)`
    color: ${(props) => props.themeType === JackpotThemeType.Light ? props.theme.colors.brandPrimaryContrast : props.theme.colors.brandSecondary};
`;
